import EventEmitter from './EventEmitter'
import EventTypes from './EventTypes'

/**
 * Класс знающий все события на уровне приложения, через него должна просиходить подписка на события и вызов события.
 * Новые типы событий перечислять в {@link EventTypes}.
 * Подписку и вещание новых событий реализовывать через этот класс добавля новые методы.
 */
export default class EventEmitterManager {
   static instance = null
   #eventEmitter = new EventEmitter()

   constructor() {
      if (EventEmitterManager.instance) {
         return EventEmitterManager.instance
      }
      return EventEmitterManager.instance = this
   }

   /** Управление событиями блока offer-slider */
   static subscribeScrolledBelowOfferSlider = (callback) =>
      new EventEmitterManager().getEventEmitter().onSubscribe(EventTypes.SCROLLED_BELOW_OFFER_SLIDER, callback)

   static emitScrolledBelowOfferSlider = () =>
      new EventEmitterManager().getEventEmitter().onEmit(EventTypes.SCROLLED_BELOW_OFFER_SLIDER)

   static subscribeScrolledAboveOfferSlider = (callback) =>
      new EventEmitterManager().getEventEmitter().onSubscribe(EventTypes.SCROLLED_ABOVE_OFFER_SLIDER, callback)

   static emitScrolledAboveOfferSlider = () =>
      new EventEmitterManager().getEventEmitter().onEmit(EventTypes.SCROLLED_ABOVE_OFFER_SLIDER)

   /** Управление событиями блока looking-for */
   static subscribeScrolledBelowLookingFor = (callback) =>
      new EventEmitterManager().getEventEmitter().onSubscribe(EventTypes.SCROLLED_BELOW_LOOKING_FOR, callback)

   static emitScrolledBelowLookingFor = () =>
      new EventEmitterManager().getEventEmitter().onEmit(EventTypes.SCROLLED_BELOW_LOOKING_FOR)

   static subscribeScrolledAboveLookingFor = (callback) =>
      new EventEmitterManager().getEventEmitter().onSubscribe(EventTypes.SCROLLED_ABOVE_LOOKING_FOR, callback)

   static emitScrolledAboveLookingFor = () =>
      new EventEmitterManager().getEventEmitter().onEmit(EventTypes.SCROLLED_ABOVE_LOOKING_FOR)

   getEventEmitter = () => EventEmitterManager.instance.#eventEmitter
}